import { DocumentNode } from "@apollo/client";

import Typography from "ds/components/Typography";
import { ApiKey } from "types/generated";
import { pluralize } from "shared/Pluralize";
import Box from "ds/components/Box";
import TextEllipsis from "ds/components/TextEllipsis";

type ApiKeysListItemGroupsCellProps = {
  apiKey: ApiKey;
  refetchQueriesOnDelete?: DocumentNode[];
};

const ApiKeysListItemGroupsCell = ({ apiKey }: ApiKeysListItemGroupsCellProps) => {
  const teamCount = `${apiKey.teamCount} ${pluralize("group", apiKey.teamCount)}`;

  return (
    <Box fullWidth gap="large">
      <TextEllipsis tooltip={teamCount} tooltipWidthMode="maxWidthSm">
        {(props) => (
          <Typography {...props} tag="span" variant="p-body3">
            {teamCount}
          </Typography>
        )}
      </TextEllipsis>
    </Box>
  );
};

export default ApiKeysListItemGroupsCell;
